import {
    Backdrop,
    Box,
    Button,
    CircularProgress,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
    useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SelectComponent from "../../components/SelectComponent/SelectComponent";
import { useTheme } from "@emotion/react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import HorecaComponent from "./HorecaComponent";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { getCombinationListReservation } from "../../api/combination.service";
import ActivityComponent from "./ActivityComponent";
import { useDispatch, useSelector } from "react-redux";
import lang from "../../assets/lang.png";
import {
    setIsOpenWidget,
    setLanguageID,
    updateCombinationListData,
    updateCombinationdatas,
    updateDefaultLanguage,
    updateLanguageData,
    updateSelectedWidget,
} from "../../store/slice/Combination.slice";
import TicketingComponent from "./TicketingComponent";
import { resetWidget } from "../../store/slice/widgetSetting.slice";
import { getLanguageDetails } from "../../api/HorecaWidget.service";
import { useLocation } from "react-router-dom";
import { send } from "../../utils/utils";
import InactivityPopup from "../../utils/InActivityPopup";

const ReservationBooking = ({ floating }) => {
    const location = useLocation();
    const deviceId = JSON.parse(localStorage.getItem("deviceId"));
    const { isOpenWidget,selectedWidget,languageId } = useSelector((store) => store?.Combination);
    const [openWidget, setOpenWidget] = useState(
        location?.state?.openWidgetScreen ?? isOpenWidget
    );
    const getWidgetPositionStyle = (position, btn) => {
        switch (position) {
            case "Top-Left":
                return { top: "0", left: "0", transform: "translate(0, 0)" };
            case "Top-Middle":
                return { top: "0", left: "50%", transform: "translateX(-50%)" };
            case "Top-Right":
                return { top: "0", right: "0", transform: "translate(0, 0)" };
            case "Middle-Left":
                return { top: "50%", left: "0", transform: "translateY(-50%)" };
            case "Middle-Center":
                return { top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
            case "Middle-Right":
                return { top: "50%", right: "0", transform: "translateY(-50%)" };
            case "Bottom-Left":
                return { bottom: "0", left: "0", transform: "translate(0, 0)" };
            case "Bottom-Middle":
                return { bottom: "0", left: "50%", transform: "translateX(-50%)" };
            case "Bottom-Right":
                return { bottom: "0", right: "0", transform: "translate(0, 0)" };
            default:
                // Center by default if position not recognized
                if (btn) {
                    return { bottom: "0", right: "0", transform: "translate(0, 0)" };
                } else {
                    return {
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                    };
                }
        }
    };
    const theme = useTheme();
    const { widgetConfig, buttonText } = useSelector(
        (store) => store?.widgetSettings
    );
    const queryParams = new URLSearchParams(location.search);
    const { CombinationListData, defaultLang, languageData } = useSelector(
        (store) => store?.Combination
    );
    const { CombinationLang } = useSelector((store) => store?.widgetSettings);
    const [isLoading, setIsLoading] = useState(false);
    const { key, resType, widgetSetupId } = useSelector(
        (store) => store?.widgetSettings
    );
    const dispatch = useDispatch();
    const getCombinationReservationList = async (key) => {
        setIsLoading(true);
        try {
            const response = await getCombinationListReservation(key);
            dispatch(updateCombinationdatas(response));
            dispatch(
                updateCombinationListData(JSON.parse(response[0]?.combinationList))
            );
            setIsLoading(false);
        } catch (error) {
            console.error(
                "Error fetching combination reservation list",
                error?.message
            );
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (key && CombinationListData?.length == 0) {

            getCombinationReservationList(key);
        }
    }, [key]);
    useEffect(() => {
        if (CombinationListData?.length > 0 && Object.keys(selectedWidget)?.length == 0) {
          
            dispatch(updateSelectedWidget(CombinationListData[0]))
        }
    }, [CombinationListData]);

    const handleLanguageChange = (event) => {
        const selectedLangCode = event.target.value;
        const selectedLanguage = languageData?.find(
            (item) => item.langcode === selectedLangCode
        );
        dispatch(updateDefaultLanguage(selectedLanguage?.langcode));
        dispatch(setLanguageID(selectedLanguage?.idlanguage));
        localStorage.setItem(
            "widget",
            JSON.stringify({
                id: widgetSetupId,
                key: key,
                lang: selectedLanguage?.langcode,
                resType: resType,
            })
        );
    };

    const fetchLanguageDetails = async () => {
        try {
            const response = await getLanguageDetails(key);
            if (response?.status != 200) {
                console.error("Error fetching language details widget:", response);
                return;
            }
            dispatch(updateLanguageData(response?.data));
            const langParam = queryParams.get("lang");
            if (response?.data) {
                const defaultLang = !langParam
                    ? response?.data?.find((item) => item?.defaultLanguage)
                    : langParam
                        ? langParam
                        : defaultLang;
                localStorage.setItem(
                    "widget",
                    JSON.stringify({
                        key: key,
                        lang: defaultLang?.langcode,
                        resType: resType,
                        id: widgetSetupId,
                    })
                );
                dispatch(setLanguageID(defaultLang?.idlanguage));
                dispatch(updateDefaultLanguage(defaultLang?.langcode));
            }
        } catch (error) {
            console.error("Error fetching language details widget:", error?.message);
        }
    };

    useEffect(() => {
        if (key) fetchLanguageDetails();
    }, [key]);



    if (isLoading) {
        return (
            <Backdrop
                sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
                open={isLoading}
                onClick={() => setIsLoading(false)}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        );
    }
    // if(deviceId ){
    //     return(
    //     <>
    //      {deviceId && <InactivityPopup languageWords={languageWords}/>}
    //     </>
    //     )
    // }
    return (
        send("100vh", "100%", "", "0px", "0px", "", floating),
        (
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                    position: "absolute",
                    top: 0,
                    zIndex: 1000,
                    width: "100%",
                    
                }}
            >
                <Box sx={{ maxWidth: { md: 450, sm: "90%", xs: "90%" } }}>
                    {!widgetConfig?.settings?.kioskMode && <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <Box sx={{ width: "200px",mt:2 }}>
                            <img
                                src={widgetConfig?.company?.companyLogo}
                                alt="companylogo"
                                style={{ width: "100%", height: "100%", objectFit: "contain" }}
                            />
                        </Box>
                    </Box>}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            mb: 2,
                            width: "100%",
                        }}
                    >
                        <Box>
                            <Typography sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                                {CombinationLang?.bookReservation || "Book Your Reservation"}
                            </Typography>
                        </Box>

                        {languageData?.length > 1 && (
                            <FormControl
                                variant="outlined"
                                sx={{
                                    minWidth: 120,
                                    backgroundColor: theme?.widget?.langBgColor,
                                    width: { xs: "100px", md: "120px" },
                                    height: "40px",
                                    borderRadius: "5px",
                                    border: `1px solid ${theme?.widget?.inputBorderColor}`,
                                }}
                            >
                                <Select
                                    value={defaultLang}
                                    onChange={handleLanguageChange} // Set the onChange handler here
                                    // IconComponent={() => (
                                    //     <KeyboardArrowDownIcon
                                    //         sx={{ color: "black", mr: 1 }}
                                    //     />
                                    // )}
                                    displayEmpty
                                    renderValue={() => (
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <img
                                                src={lang}
                                                alt={"lang-img"}
                                                style={{ width: "40px", marginRight: "10px" }}
                                            />
                                        </Box>
                                    )}
                                    sx={{
                                        "& .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "transparent",
                                        },
                                        "&:hover .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "transparent",
                                        },
                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                            borderColor: "transparent",
                                        },
                                        "& .MuiOutlinedInput-input": {
                                            padding: 1,
                                            //     color: "#9F9F9F",
                                            fontSize: "12px",
                                        },
                                    }}
                                >
                                    {languageData?.map((item, index) => (
                                        <MenuItem
                                            key={item?.idlanguage}
                                            value={item?.langcode}
                                            sx={{
                                                color: theme?.palette?.widget?.langTextColor, // Text color of MenuItem
                                                "&.Mui-selected": {
                                                    backgroundColor: theme?.widget?.langActiveBgColor, // Highlight selected item
                                                },
                                                "&:hover": {
                                                    backgroundColor: theme?.widget?.langBgHover, // Hover effect for MenuItem
                                                    color: theme?.widget?.langTextHover,
                                                    "&.Mui-selected": {
                                                        backgroundColor: theme?.widget?.langBgHover, // Hover effect for MenuItem
                                                        color: theme?.widget?.langTextHover,
                                                    },
                                                },
                                            }}
                                        >
                                            {(item?.langcode == defaultLang?.trim()) != "" ? (
                                                <>
                                                    {item?.language}
                                                    <CheckBoxIcon
                                                        sx={{
                                                            color: theme?.widget?.langCheckboxActive,
                                                            marginRight: "8px",
                                                            ml: 2,
                                                        }}
                                                    />
                                                </>
                                            ) : (
                                                item?.language
                                            )}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                    </Box>
                    <Box sx={{ width: "100%", mb: 2}}>
                        <FormControl
                            fullWidth
                            sx={{
                                width: "100%",
                                height: "70px",

                                position: "relative",
                                backgroundColor: theme?.guest?.bgColor,

                                // Ensure the input itself doesn't have a border
                                "& .MuiInputBase-root": {
                                    border: "none",
                                    boxShadow: "none",
                                },

                                // Remove border on focus
                                "& .Mui-focused": {
                                    border: "none",
                                    boxShadow: "none",
                                },
                            }}
                        >
                            <Box>
                                <Typography
                                    sx={{
                                        position: "absolute",
                                        top: 10,
                                        left: 20,
                                        fontSize: "12px",
                                        color: theme?.widget?.inputTextColor,
                                        fontWeight: 200,
                                    }}
                                >
                                    {CombinationLang?.selectCategory || "Select Category"}
                                </Typography>
                                <KeyboardArrowDownIcon
                                    sx={{
                                        position: "absolute",
                                        top: 20,
                                        right: 20,
                                    }}
                                />
                                <Select
                                    id="demo-simple-select"
                                    value={selectedWidget || ""} // Store entire object
                                    fullWidth
                                    IconComponent={null} // Remove the default arrow icon
                                    sx={{
                                        position: "relative",
                                        width: "100%",
                                        height: "72px",
                                        "& .MuiOutlinedInput-input": {
                                            padding: 1,
                                            color: theme?.guest?.textColor,
                                            ml: 3,
                                            mt: 1,
                                            fontSize: { sm: "12px", md: "14px" },
                                        },
                                    }}
                                    onChange={(event) => {
                                        const selectedItem = CombinationListData.find(
                                            (item) => item.widgetName === event.target.value
                                        );
                                        dispatch(updateSelectedWidget(selectedItem))
                                      
                                    }}
                                    renderValue={(selected) => selected?.Title} // Display name
                                >
                                    {CombinationListData?.map((item, index) => (
                                        <MenuItem
                                            key={item?.idWidgetSetup}
                                            value={item?.widgetName} // Keep value as widgetName
                                            sx={{
                                                color: theme?.guest?.dropdownTextColor,
                                                width: "100%",
                                                fontSize: { sm: "12px", md: "1.2rem" },
                                                "&:hover": {
                                                    backgroundColor: theme?.guest?.dropdownBgHover,
                                                    color: theme?.guest?.dropdownTextColorHover,
                                                },
                                            }}
                                        >
                                            {item?.Title}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Box>
                        </FormControl>
                    </Box>
                    {selectedWidget?.widgetName == "horeca" && (
                        <HorecaComponent
                            data={selectedWidget}
                            language={defaultLang}
                            id={languageId}

                        />
                    )}
                    {selectedWidget?.widgetName == "activity" && (
                        <ActivityComponent
                            data={selectedWidget}
                            language={defaultLang}
                           
                        />
                    )}
                    {selectedWidget?.widgetName == "entree" && (
                        <TicketingComponent
                            data={selectedWidget}
                            language={defaultLang}
                        />
                    )}
                </Box>
            </Box>
        )
    );
};

export default ReservationBooking;
